<template>
<div class="cmui-textarea pos-r">
	<textarea name=""
	          class="padding20"
	          :id="id"
	          :placeholder="placeholder"
	          :class="className"
	          :maxlength="max"
	          v-model="model"
	          v-bind:style="style"
	          @input="handleInput">
	</textarea>
	<div v-if="max>=0" class="pos-a right20 bottom20 text-light">
		{{model.length}}/{{max}}
	</div>
</div>
</template>
<style lang="scss">
	.cmui-textarea textarea{
		width:100%;
		height:150px;
		border:none;
	}
</style>
<script>
	import _ from "_";
	export default {
		props:{
			id:{type:String,default:_.uniqueId('cmui_textarea')},
			model:{type:String,default:'',twoWay: true},
			placeholder:{type:String,default:'请输入'},
			max:{type:Number,default:-1},
			style:{type:Object,default:null},
			className:{type:String,default:''},
			target:Object
		},
		methods:{
			handleInput(event){
				setTimeout(() => {  
				 this.$dispatch('cmui-textarea-change', this, this.model)
				}, 10); 
			}
		}
	}
</script>